import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { createDataNodeOperation } from '../../data/fileImport/dataTreesActions';

const MetricStatus = props => {
  const titles = {
    validation: 'Validation',
    parsing: 'Parse',
    baseline: 'Baseline',
    sync: 'Synchronisation'
  };

  const { clickable, dispatch, nodeOperation, type, dataNodeId } = props;

  const status = nodeOperation ? nodeOperation.status : 'none';
  const title = titles[status];

  const getHandlerFunction = () => {
    let hasClicked = false;
    return () => {
      if (hasClicked) {
        return;
      }
      hasClicked = true;

      dispatch(createDataNodeOperation(type, dataNodeId));
    };
  };

  const onClick = clickable ? getHandlerFunction() : null;

  return (
    <span
      title={title}
      onClick={onClick}
      className={`session__metric session__metric--${type} metric__status--${status}`}
    >
      {'validate'}
    </span>
  );
};

const MetricStatusConnected = connect()(MetricStatus);

MetricStatus.propTypes = {
  type: PropTypes.string.isRequired,
  clickable: PropTypes.bool.isRequired,
  nodeOperation: PropTypes.shape({
    status: PropTypes.string.isRequired
  }),
  dataNodeId: PropTypes.number
};

MetricStatus.defaultProps = {
  nodeOperation: null,
  dataNodeId: null
};

const DataNodeStatus = props => {
  const { dataNode } = props;

  if (!dataNode) {
    return null;
  }

  return (
    <div className="session__metrics--container">
      <MetricStatusConnected
        type="validation"
        clickable={dataNode.node_validation === null}
        dataNodeId={dataNode.id}
        nodeOperation={dataNode.node_validation}
      />
      <MetricStatusConnected
        type="parsing"
        clickable={false}
        dataNodeId={dataNode.id}
        nodeOperation={dataNode.node_parsing}
      />
      <MetricStatusConnected
        type="baseline"
        clickable={false}
        dataNodeId={dataNode.id}
        nodeOperation={dataNode.node_baseline}
      />
      <MetricStatusConnected
        type="sync"
        clickable={false}
        dataNodeId={dataNode.id}
        nodeOperation={dataNode.node_sync}
      />
    </div>
  );
};

DataNodeStatus.propTypes = {
  dataNode: PropTypes.shape({
    node_validation: PropTypes.shape({
      status: PropTypes.string.isRequired
    }),

    node_parsing: PropTypes.shape({
      status: PropTypes.string.isRequired
    }),

    node_baseline: PropTypes.shape({
      status: PropTypes.string.isRequired
    }),

    node_node_sync: PropTypes.shape({
      status: PropTypes.string.isRequired
    })
  })
};

DataNodeStatus.defaultProps = {
  dataNode: null
};

export default DataNodeStatus;



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/DataNodeStatus.js